import type { ITemplate } from "@framework/types";
import { cleanUpAsset } from "@framework/exchange";

export const collectionsTemplatesCreateFilter = ({
  title,
  description,
  price,
  amount,
  imageUrl,
  contractId,
}: ITemplate) => ({
  title,
  description,
  price: cleanUpAsset(price) as any,
  amount,
  imageUrl,
  contractId,
});

export const collectionsTemplatesEditFilter = ({
  title,
  description,
  price,
  amount,
  imageUrl,
  templateStatus,
}: ITemplate) => ({
  title,
  description,
  price: cleanUpAsset(price) as any,
  amount,
  imageUrl,
  templateStatus,
});

export const prepareCollectionsTemplatesInitialValues = ({
  id,
  title,
  description,
  price,
  amount,
  templateStatus,
  contractId,
  imageUrl,
}: Partial<ITemplate>) => {
  return {
    id,
    title,
    description,
    price,
    amount,
    templateStatus,
    contractId,
    imageUrl,
  };
};
